<template>
  <!-- 保单信息 -->
  <div>
    <loading :isShow="loading" />
    <div class="body">
      <Form ref="formInline" class="page-form" :model="formData" :label-width="90">
        <FormItem label="产品名称" prop="productCode" :rules="$units.formRule.required('请选择')">
          <Select
            ref="resetSelect"
            :label-in-value="true"
            v-model="formData.productCode"
            @on-change="changeProduct($event)"
            placeholder="请选择"
            filterable
            clearable
          >
            <Option :value="product.productCode" v-for="product in productListArr" :label="product.productCode + '/' + product.productName" :key="product.id">
              <Tag v-if="product.supplierName" color="blue">{{ product.supplierName }}</Tag>
              {{ product.productCode }}/{{ product.productName }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="产品档次" prop="grade" :rules="$units.formRule.required('请选择')">
          <Select placeholder="请选择" v-model="formData.grade" :label-in-value="true" filterable clearable>
            <Option v-for="bean in gradeList" :value="bean.programName" :key="bean.programId">{{ bean.programName }}</Option>
          </Select>
        </FormItem>

        <div class="title">
          <div class="title-desc">出单信息</div>
        </div>
        <FormItem label="出单团队" prop="groupId" :rules="$units.formRule.required('请选择出单团队')">
          <selectTree ref="selectTreeRef1" type="1" v-model="formData.groupId" @change="selectTreeChange" @getTreeData="getTreeData"></selectTree>
        </FormItem>
        <FormItem label="出单机构" prop="orgName">
          <Input type="text" v-model="formData.orgName" placeholder="选择团队或业务员后自动回显" disabled />
        </FormItem>
        <FormItem label="出单业务员" prop="salesmanId" :rules="$units.formRule.required('请选择出单业务员')">
          <Select placeholder="请选择" v-model="formData.salesmanId" @on-change="selectSalesMan" clearable filterable>
            <Option v-for="(item, i) in userList" :key="i" :value="item.id">
              {{ item.staffNo ? item.name + '-' + item.staffNo : item.name }}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="保单号" prop="policyNo" :rules="$units.formRule.required('请输入')">
          <Input type="text" :disabled="editFlag == 'edit' ? true : false" v-model="formData.policyNo" placeholder="请输入" clearable />
        </FormItem>
        <FormItem label="保单状态" prop="status" :rules="$units.formRule.required('请选择')">
          <Select v-model="formData.status" placeholder="请选择">
            <Option value="1">承保中</Option>
            <Option value="0">已终止</Option>
            <Option value="-1">已退保</Option>
          </Select>
        </FormItem>
        <FormItem label="投保日期" prop="insureTime" :rules="$units.formRule.objRequired('请选择投保日期')">
          <DatePicker type="date" v-model="formData.insureTime" format="yyyy-MM-dd" placeholder="选择日期"></DatePicker>
        </FormItem>
        <FormItem label="承保日期" prop="issueTime" :rules="$units.formRule.objRequired('请选择承保日期')">
          <DatePicker type="date" v-model="formData.issueTime" @on-change="issueTimeChange" format="yyyy-MM-dd" placeholder="选择日期"></DatePicker>
        </FormItem>
        <FormItem label="支付日期" prop="payTime" :rules="$units.formRule.objRequired('请选择支付日期')">
          <DatePicker type="date" v-model="formData.payTime" format="yyyy-MM-dd" placeholder="选择日期"></DatePicker>
        </FormItem>
        <FormItem label="生效日期" prop="startTime" :rules="$units.formRule.objRequired('请选择生效日期')">
          <DatePicker type="date" v-model="formData.startTime" format="yyyy-MM-dd" placeholder="选择日期"></DatePicker>
        </FormItem>
        <FormItem label="终保日期" prop="endTime" :rules="$units.formRule.objRequired('请选择终保日期')">
          <DatePicker type="date" v-model="formData.endTime" format="yyyy-MM-dd" placeholder="选择日期"></DatePicker>
        </FormItem>
        <FormItem
          :label-width="100"
          label="退保生效日期"
          prop="refundStartTime"
          :rules="$units.formRule.objRequired('请选择退保生效日期')"
          v-if="formData.status == '-1'"
          key="refundStartTime"
        >
          <DatePicker type="date" v-model="formData.refundStartTime" format="yyyy-MM-dd" placeholder="选择日期"></DatePicker>
        </FormItem>
        <FormItem label="退保金额" prop="refundFee" :rules="$units.formRule.required('请输入')" v-if="formData.status == '-1'">
          <Input type="text" v-model="formData.refundFee" placeholder="请输入" clearable />
        </FormItem>
        <FormItem label="业务来源" prop="businessSource" v-if="$units.superviseShowVal()">
          <Select v-model="formData.businessSource" placeholder="请选择" clearable>
            <Option value="1">直营</Option>
            <Option value="2">分销</Option>
          </Select>
        </FormItem>
        <FormItem label="供应商类型" prop="supplierType" v-if="$units.showSupplier()">
          <Select v-model="formData.supplierType" placeholder="请选择供应商类型" @on-change="selectSupplier" clearable>
            <Option value="1">保司</Option>
            <Option value="2">通道</Option>
          </Select>
        </FormItem>
        <FormItem label="供应商" prop="supplierId" v-if="$units.showSupplier()">
          <Select v-model="formData.supplierId" placeholder="请选择供应商" clearable filterable>
            <Option :value="item.id" v-for="(item, index) in supplierList" :key="index">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="保费(元)" prop="fee" :rules="$units.formRule.required('请输入')">
          <Input type="text" v-model="formData.fee" :maxlength="30" placeholder="请输入" clearable />
        </FormItem>
        <FormItem label="是否为多被保人" prop="isManyInsures" :label-width="105">
          <Select v-model="formData.isManyInsures" placeholder="请选择" clearable>
            <Option value="1">是</Option>
            <Option value="0">否</Option>
          </Select>
        </FormItem>

        <div class="title">
          <div class="title-desc">投保企业信息</div>
        </div>
        <FormItem label="企业工商名" prop="name" :rules="$units.formRule.required('请输入')">
          <Input type="text" v-model="formData.name" placeholder="请输入" clearable />
        </FormItem>
        <FormItem label="统一社会信用代码" :label-width="125" prop="cardNo" :rules="$units.formRule.required('请输入')">
          <Input type="text" v-model="formData.cardNo" placeholder="请输入" clearable />
        </FormItem>
        <FormItem label="企业电话">
          <div class="tips">
            <Input
              type="text"
              v-if="formData.eyeShow || !formData.policyNo || !mobileEye"
              v-model="formData.contactMobile"
              :maxlength="30"
              @on-change="dataChange($event, 1)"
              placeholder="请输入"
              clearable
            />
            <Input type="text" v-else v-model="formData.contactMobile1" :maxlength="30" @on-change="dataChange($event, 1)" placeholder="请输入" clearable />
            <span v-if="mobileEye && formData.contactMobile1">
              <i class="iconfont iconxianshi eye-icon" v-if="formData.eyeShow && formData.policyNo" @click="openEye('contactMobile', 'eyeShow')"></i>
              <i class="iconfont iconyincang eye-icon" v-else-if="!formData.eyeShow && formData.policyNo" @click="openEye('contactMobile', 'eyeShow')"></i>
            </span>
          </div>
        </FormItem>
        <FormItem label="企业联系人">
          <Input type="text" v-model="formData.contactName" :maxlength="30" placeholder="请输入" clearable />
        </FormItem>
        <FormItem label="手机号" prop="mobile" :rules="mobileEye1 ? { required: false, message: '请输入' } : $units.formRule.phone()">
          <div class="tips">
            <Input
              type="text"
              v-if="formData.eyeShow1 || !formData.policyNo || !mobileEye1"
              v-model="formData.mobile"
              :maxlength="11"
              @on-change="dataChange($event, 2)"
              placeholder="请输入"
              clearable
            />
            <Input type="text" v-else v-model="formData.mobile1" :maxlength="11" @on-change="dataChange($event, 2)" placeholder="请输入" clearable />
            <span v-if="mobileEye1 && formData.mobile1">
              <i class="iconfont iconxianshi eye-icon" v-if="formData.eyeShow1 && formData.policyNo" @click="openEye('mobile', 'eyeShow1')"></i>
              <i class="iconfont iconyincang eye-icon" v-else-if="!formData.eyeShow1 && formData.policyNo" @click="openEye('mobile', 'eyeShow1')"></i>
            </span>
          </div>
        </FormItem>
        <FormItem label="身份证号" prop="contactCardNo" :rules="contactCardNoEye ? { required: false, message: '请输入' } : $units.formRule.IDNumber()">
          <div class="tips">
            <Input
              type="text"
              v-if="formData.eyeShow2 || !formData.policyNo || !contactCardNoEye"
              v-model="formData.contactCardNo"
              :maxlength="18"
              @on-change="dataChange($event, 3)"
              placeholder="请输入"
              clearable
            />
            <Input type="text" v-else v-model="formData.contactCardNo1" :maxlength="18" @on-change="dataChange($event, 3)" placeholder="请输入" clearable />
            <span v-if="contactCardNoEye && formData.contactCardNo1">
              <i class="iconfont iconxianshi eye-icon" v-if="formData.eyeShow2 && formData.policyNo" @click="openEye('contactCardNo', 'eyeShow2')"></i>
              <i class="iconfont iconyincang eye-icon" v-else-if="!formData.eyeShow2 && formData.policyNo" @click="openEye('contactCardNo', 'eyeShow2')"></i>
            </span>
          </div>
        </FormItem>
        <FormItem label="邮箱" prop="email" :rules="emailEye ? { required: false, message: '请输入' } : $units.formRule.email(false)">
          <div class="tips">
            <Input
              type="text"
              v-if="formData.eyeShow3 || !formData.policyNo || !emailEye"
              v-model="formData.email"
              :maxlength="30"
              @on-change="dataChange($event, 4)"
              placeholder="请输入"
              clearable
            />
            <Input type="text" v-else v-model="formData.email1" :maxlength="30" @on-change="dataChange($event, 4)" placeholder="请输入" clearable />
            <span v-if="emailEye && formData.email1">
              <i class="iconfont iconxianshi eye-icon" v-if="formData.eyeShow3 && formData.policyNo" @click="openEye('email', 'eyeShow3')"></i>
              <i class="iconfont iconyincang eye-icon" v-else-if="!formData.eyeShow3 && formData.policyNo" @click="openEye('email', 'eyeShow3')"></i>
            </span>
          </div>
        </FormItem>
        <FormItem label="企业所在地">
          <Input type="text" v-model="formData.location" :maxlength="30" placeholder="请输入" clearable />
        </FormItem>
        <FormItem label="注册地址">
          <div class="tips">
            <Input
              type="text"
              v-if="formData.eyeShow4 || !formData.policyNo || !addressEye"
              v-model="formData.address"
              :maxlength="30"
              @on-change="dataChange($event, 5)"
              placeholder="请输入"
              clearable
            />
            <Input type="text" v-else v-model="formData.address1" :maxlength="30" @on-change="dataChange($event, 5)" placeholder="请输入" clearable />
            <span v-if="addressEye && formData.address1">
              <i class="iconfont iconxianshi eye-icon" v-if="formData.eyeShow4 && formData.policyNo" @click="openEye('address', 'eyeShow4')"></i>
              <i class="iconfont iconyincang eye-icon" v-else-if="!formData.eyeShow4 && formData.policyNo" @click="openEye('address', 'eyeShow4')"></i>
            </span>
          </div>
        </FormItem>
        <FormItem label="企业性质">
          <Select v-model="formData.enterpriseNature" filterable clearable>
            <Option v-for="(txt, value) in enterpriseNatureList" :value="txt" :key="value">{{ txt }}</Option>
          </Select>
        </FormItem>
        <FormItem label="所属行业">
          <Input type="text" v-model="formData.belongIndustry" :maxlength="30" placeholder="请输入" clearable />
        </FormItem>
        <FormItem label="银行卡户名">
          <Input type="text" v-model="formData.accountName" :maxlength="30" placeholder="请输入" clearable />
        </FormItem>
        <FormItem
          label="银行账户"
          prop="accountNumber"
          :rules="accountNumberEye ? { required: false, message: '请输入' } : accoutNumber('请输入正确的银行账户')"
        >
          <div class="tips">
            <Input
              type="text"
              v-if="formData.eyeShow5 || !formData.policyNo || !accountNumberEye"
              v-model="formData.accountNumber"
              :maxlength="30"
              @on-change="cardNoChange"
              placeholder="请输入"
              clearable
            />
            <Input type="text" v-else v-model="formData.accountNumber1" :maxlength="30" @on-change="cardNoChange" placeholder="请输入" clearable />
            <span v-if="accountNumberEye && formData.accountNumber1">
              <i class="iconfont iconxianshi eye-icon" v-if="formData.eyeShow5 && formData.policyNo" @click="openEye('accountNumber', 'eyeShow5')"></i>
              <i class="iconfont iconyincang eye-icon" v-else-if="!formData.eyeShow5 && formData.policyNo" @click="openEye('accountNumber', 'eyeShow5')"></i>
            </span>
          </div>
        </FormItem>
        <FormItem label="开户行">
          <Select v-model="formData.openAccountBank" filterable clearable>
            <Option v-for="(txt, value) in bankList" :value="txt" :key="value">{{ txt }}</Option>
          </Select>
        </FormItem>

        <div class="title">
          <div class="title-desc">保障责任</div>
        </div>

        <Form v-for="(right, r) in formData.guarantee" :key="`rights-${r}`" :label-width="90">
          <FormItem label="职业类别" prop="jobGrade">
            <Input type="text" v-model="right.jobGrade" placeholder="请输入" clearable />
          </FormItem>
          <FormItem label="计划方案" prop="planName">
            <Input type="text" v-model="right.planName" placeholder="请输入" clearable />
          </FormItem>
          <FormItem :label-width="0">
            <Button type="primary" ghost @click="handleAddGuarantee(formData.guarantee)">+ 新增</Button>
            <Button
              type="error"
              style="margin-left: 10px"
              v-if="formData.guarantee.length > 1 && r + 1 == formData.guarantee.length"
              @click="formData.guarantee.pop()"
              >- 删除</Button
            >
          </FormItem>
          <FormItem label="保障责任" prop="guarantee" class="two">
            <Input type="textarea" v-model="right.guarantee" placeholder="请输入" clearable />
          </FormItem>
        </Form>

        <div class="title">
          <div class="title-desc">标的信息</div>
        </div>
        <FormItem label="项目名称">
          <Input type="text" v-model="formData.projectName" :maxlength="30" placeholder="请输入" clearable />
        </FormItem>
        <FormItem label="所在区域">
          <Input type="text" v-model="formData.localtionArea" :maxlength="30" placeholder="请输入" clearable />
        </FormItem>
        <FormItem label="详细地址">
          <Input type="text" v-model="formData.detailAddress" :maxlength="30" placeholder="请输入" clearable />
        </FormItem>

        <div class="title">
          <div class="title-desc">受益人信息</div>
        </div>
        <FormItem label="受益人类型" prop="beneficiaryType">
          <Select v-model="formData.beneficiaryType" placeholder="请选择">
            <Option value="2">共同被保险人</Option>
            <Option value="1">受益人</Option>
          </Select>
        </FormItem>

        <div class="title">
          <div class="title-desc">影像资料</div>
        </div>
        <div class="nav-second-tab">
          <div class="tab-body">
            <span v-for="(theme, i) in themeList" :class="i == themeActive ? 'active' : ''" :key="i + ' '" @click="themeClick(i)">{{ theme }}</span>
          </div>
        </div>
        <upload v-if="themeActive == 0" :imgArr="insuranceContractList" @handleSuccess="handleSuccess"></upload>
        <upload v-if="themeActive == 1" :imgArr="insuranceInfoList" @handleSuccess="handleSuccess"></upload>
        <upload v-if="themeActive == 2" :imgArr="customerNoticeList" @handleSuccess="handleSuccess"></upload>
        <upload v-if="themeActive == 3" :imgArr="otherInfoList" @handleSuccess="handleSuccess"></upload>
      </Form>
    </div>
  </div>
</template>

<script>
import selectTree from '@/components/system/selectTree3';
import areaTree from '@/components/commons/selectTree';
import upload from '../components/upload';
import filter from '@/api/filter';
import { mapState } from 'vuex';
import { common } from '@/api/mixins';
import _ from 'lodash';

export default {
  mixins: [common],
  name: 'policyInfoForm',
  props: {
    editFlag: null
  },
  components: {
    selectTree,
    areaTree,
    upload
  },
  data() {
    return {
      accoutNumber(msg) {
        return {
          pattern: /^[0-9]*$/,
          message: msg,
          trigger: 'blur'
        };
      },
      mobileEye: true,
      mobileEye1: true,
      emailEye: true,
      addressEye: true,
      contactCardNoEye: true,
      accountNumberEye: true,
      dic: JSON.parse(localStorage.dic),
      filter,
      draftId: '', //草稿id
      orderNo: '',
      themeActive: 0,
      supplierList: [], //供应商
      productListArr: [], // 产品名称列表
      gradeList: [], //主险产品档次列表
      additionGradeList: [], //附加险产品方案档次列表
      loading: false,
      salesmanList: [], // 出单机构业务员列表
      userList: [],
      insuranceInfoList: [], //投保确认书
      insuranceContractList: [], // 保险合同列表
      customerNoticeList: [], //投保人声明
      otherInfoList: [], //其他
      uploadList: 'insuranceContractList',
      themeList: ['保险合同', '投保确认书', '投保人声明', '其他'],
      bankList: [], //开户银行
      enterpriseNatureList: [], //企业性质
      detailData: {},
      groupId: '',
      //基础信息
      formData: {
        /*********************一、保单信息******************************/
        productCode: '', // 产品code
        productName: '', // 产品名称
        grade: '', // 产品档次
        /*********************出单信息******************************/
        orgId: '', // 出单机构id
        groupId: '', // 出单团队
        salesmanId: '', // 出单业务员id
        policyNo: '', //保单号
        status: '', // 保单状态
        insureTime: '', //投保日期
        issueTime: '', // 承保日期
        payTime: '', // 支付日期
        startTime: '', // 生效日期
        endTime: '', // 终保日期
        refundStartTime: '', //退保生效日期
        refundFee: '', //退保金额
        businessSource: '', // 业务来源
        supplierType: '', //供应商类型
        supplierId: '', //供应商
        fee: '', //保费
        isManyInsures: '', //是否为多被保人
        /*********************投保企业信息******************************/
        name: '', //企业工商名
        cardNo: '', //统一社会信用代码
        contactMobile: '', //企业电话
        contactName: '', //企业联系人
        mobile: '', //手机号
        contactCardNo: '', //身份证号
        email: '', //邮箱
        location: '', //企业所在地
        address: '', //注册地址
        enterpriseNature: '', //企业性质
        belongIndustry: '', //所属行业
        accountName: '', //银行卡户名
        accountNumber: '', //银行账户
        openAccountBank: '', //开户行
        /*********************保障责任******************************/
        guarantee: [
          {
            jobGrade: '', //职业类别
            planName: '', //计划名称
            guarantee: '' //保障责任
          }
        ],
        /*********************标的信息******************************/
        projectName: '', //项目名称
        localtionArea: '', //所在区域
        detailAddress: '', //详细地址
        /*********************受益人信息******************************/
        beneficiaryType: ''
        /*********************影像资料******************************/
      }
    };
  },

  created() {
    this.setData();
  },

  computed: {
    ...mapState(['userInfo'])
  },
  methods: {
    // 解密
    openEye(key, showKey) {
      if (!this.formData[showKey]) {
        const map = {
          contactCardNo: 1,
          mobile: 2,
          accountNumber: 3,
          email: 4,
          address: 5,
          contactMobile: 7
        };
        this.descrypt(
          {
            query: this.formData.policyNo,
            operationFunction: 41,
            operationType: map[key]
          },
          this.formData,
          key
        ).then(() => {
          this.$set(this.formData, showKey, true);
        });
      } else {
        this.$set(this.formData, showKey, false);
      }
    },
    // 信息修改
    dataChange(e, val) {
      if (val == 1) {
        this.$set(this.formData, 'contactMobile', e.target.value);
        this.mobileEye = false;
      } else if (val == 2) {
        this.$set(this.formData, 'mobile', e.target.value);
        this.mobileEye1 = false;
      } else if (val == 3) {
        this.$set(this.formData, 'contactCardNo', e.target.value);
        this.contactCardNoEye = false;
      } else if (val == 4) {
        this.$set(this.formData, 'email', e.target.value);
        this.emailEye = false;
      } else if (val == 5) {
        this.$set(this.formData, 'address', e.target.value);
        this.addressEye = false;
      }
    },
    async setData() {
      this.getProductList();
      this.getBankList();
      this.getEnterpriseNature();
      this.getUserList();
      if (this.$route.query.policyNo) {
        this.formData.policyNo = this.$route.query.policyNo;
      }
      if (this.formData.policyNo) {
        this.getDetail();
      }
      this.$nextTick(() => {
        this.$refs.selectTreeRef1 && this.$refs.selectTreeRef1.openChange();
      });
    },

    // 选择承保时间 复写支付时间
    issueTimeChange() {
      if (!this.formData.payTime) {
        this.formData.payTime = this.formData.issueTime;
      }
    },

    // 获取当前机构业务员
    getUserList() {
      this.$http({
        url: '/buz/userBase/getSubUser',
        type: 'get',
        data: {
          isValid: 1,
          orgId: this.userInfo.organId
        }
      }).then(res => {
        this.userList = res.data;
      });
    },

    // 输入银行卡获取开户行
    cardNoChange(e) {
      this.$set(this.formData, 'accountNumber', e.target.value);
      this.accountNumberEye = false;
      const cardNo = e.target.value;
      if (cardNo && cardNo.length > 15 && cardNo.length < 20) {
        this.$http({
          url: '/buz/userCertificate/queryBankByCardNo',
          type: 'GET',
          data: {
            cardNo
          }
        }).then(res => {
          if (res.data) {
            this.getBankList();
            for (let i in this.bankList) {
              if (this.bankList[i] == res.data) {
                this.$set(this.formData, 'openAccountBank', res.data);
              }
            }
          }
        });
      } else if (!cardNo) {
        this.$set(this.formData, 'openAccountBank', '');
      }
    },

    // 获取银行列表
    getBankList() {
      this.bankList = this.dic['BANK_TYPE'];
    },

    // 获取企业性质
    getEnterpriseNature() {
      this.enterpriseNatureList = this.dic['GROUP_ENTERPRISE_NATURE'];
      console.log(this.enterpriseNatureList);
    },

    // 获取产品列表
    getProductList() {
      this.$http({
        url: '/buz/grouppolicy/enter/productList',
        type: 'POST',
        data: {
          pageNo: 1,
          pageSize: 9999
        }
      }).then(res => {
        this.productListArr = res.data;
      });
    },

    // 选择产品
    changeProduct(val) {
      this.formData.supplierId = '';
      this.formData.supplierType = '';
      if (!val) {
        return;
      }
      if (val.label) {
        this.formData.grade = '';
        this.productListArr.map(item => {
          if (item && item.productCode == val.value) {
            // 产品id
            this.formData.productId = item.id;

            // 产品名称
            this.formData.productName = item.productName;
            this.formData.productCode = item.productCode;

            // 回显供应商类型、供应商
            if (item.supplierType && item.supplierId) {
              this.formData.supplierType = item.supplierType;
              this.formData.supplierId = item.supplierId;
              this.selectSupplier(item.supplierType);
            }
          }
        });
      }
      this.getProductGrade(this.formData.productCode, true);
    },

    // 供应商类型
    selectSupplier(val) {
      this.supplierList = [];
      this.$http({
        url: val == 1 ? '/buz/insuranceCompany/read/list' : '/buz/insuranceChannel/read/list',
        type: 'POST',
        data: {}
      }).then(res => {
        this.supplierList = res.data;
      });
    },

    // 产品档次列表
    getProductGrade(code, isMain) {
      /*
              isMain:true主险，false附加险
          */
      if (isMain) {
        //主险
        this.gradeList = [];
      } else {
        //附加险
        this.additionGradeList = [];
      }
      if (!code) {
        return;
      }
      this.$http({
        url: '/buz/programBase/queryAllProductGrade',
        type: 'post',
        data: {
          productCode: code,
          isMain
        }
      }).then(res => {
        if (isMain) {
          this.gradeList = res.data;
        } else {
          this.additionGradeList = res.data;
        }
        if (res.data && res.data.length == 1) {
          this.$set(this.formData, 'grade', res.data[0].programName);
          this.additionGradeList = res.data;
        }
      });
    },

    // msg: _.throttle(
    //     function () {
    //         this.$notice.msg('保单信息修改后，保单服务费将发生变化');
    //     },
    //     2000,
    //     { trailing: false }
    // ),

    // 选择出单业务员
    selectSalesMan(id) {
      this.getUserList();
      const bean = this.userList.find(item => {
        return item.id == id;
      });
      if (bean) {
        this.formData.salesmanName = bean.name;
        this.formData.groupId = bean.groupId;
        this.formData.orgId = bean.organizationId;
        this.formData.orgName = bean.organizationName;
      } else {
        this.formData.salesmanName = '';
      }
    },

    // 机构树选择
    selectTreeChange(data) {
      this.getUserList();
      // 判断业务员当前出单组织是否与实际相符，如果不相符则清空
      const bean = this.userList.find(item => {
        return item.id == this.formData.salesmanId;
      });
      if (bean) {
        if (bean.groupId != this.formData.groupId) {
          this.formData.salesmanId = '';
        }
      }
      this.formData.orgName = data.orgName;
      this.formData.groupId = data.id;
      this.formData.orgId = data.orgId;
    },

    // 获取树节点id
    getTreeData(data) {
      this.depData(data);
    },
    depData(data) {
      data.forEach(item => {
        if (!item.orgId) {
          this.$set(item, 'disabled', true);
        }
        item.children.length ? this.depData(item.children) : [];
      });
    },

    // 切换影像资料tab
    themeClick(index) {
      this.themeActive = index;
      if (index == 0) {
        this.uploadList = 'insuranceContractList';
      } else if (index == 1) {
        this.uploadList = 'insuranceInfoList';
      } else if (index == 2) {
        this.uploadList = 'customerNoticeList';
      } else if (index == 3) {
        this.uploadList = 'otherInfoList';
      }
    },
    // 新增保障责任
    handleAddGuarantee(guarantee) {
      let obj = {
        jobGrade: '', //职业类别
        planName: '', //计划名称
        guarantee: '' //保障责任
      };
      guarantee.push(obj);
    },
    // 是否是图片
    isImage(url) {
      return /\.(png|jpg|jpeg)$/.test(url.toLowerCase());
    },
    // 影像资料上传
    handleSuccess(res, file) {
      if (res.httpCode == 1) {
        res.data.map((item, index) => {
          let url = item.path;
          let isImage = this.isImage(url);
          let type = isImage ? 'image' : 'pdf';
          this[this.uploadList].push({
            url,
            type,
            show: false
          });
        });
      }
    },
    // 详情
    getDetail(reload) {
      let isCopy;
      if (this.editFlag == 'copy') {
        isCopy = 1;
      }
      this.loading = true;
      this.$http({
        type: 'GET',
        url: '/buz/grouppolicy/enter/detail',
        data: {
          policyNo: this.formData.policyNo,
          isCopy: isCopy
        }
      })
        .then(res => {
          this.groupId = res.data.groupPolicy.groupId;
          this.detailData = res.data;
          this.orderNo = res.data.groupPolicy.orderNo;
          this.formData.productCode = res.data.groupPolicy.productCode;
          this.formData.productName = res.data.groupPolicy.productName;
          this.formData.grade = res.data.groupPolicy.grade;
          this.formData.orgId = res.data.groupPolicy.orgId;
          this.formData.groupId = res.data.groupPolicy.groupId;
          this.formData.salesmanId = res.data.groupPolicy.salesmanId;
          this.formData.policyNo = res.data.groupPolicy.policyNo;
          this.formData.status = res.data.groupPolicy.status;
          this.formData.insureTime = res.data.groupPolicy.insureTime && filter.filterTime(res.data.groupPolicy.insureTime, 'YYYY-MM-DD');
          this.formData.issueTime = res.data.groupPolicy.issueTime && filter.filterTime(res.data.groupPolicy.issueTime, 'YYYY-MM-DD');
          this.formData.payTime = res.data.groupPolicy.payTime && filter.filterTime(res.data.groupPolicy.payTime, 'YYYY-MM-DD');
          this.formData.startTime = res.data.groupPolicy.startTime && filter.filterTime(res.data.groupPolicy.startTime, 'YYYY-MM-DD');
          this.formData.endTime = res.data.groupPolicy.endTime && filter.filterTime(res.data.groupPolicy.endTime, 'YYYY-MM-DD');
          this.formData.refundStartTime = res.data.groupPolicy.refundStartTime && filter.filterTime(res.data.groupPolicy.refundStartTime, 'YYYY-MM-DD');
          this.formData.refundFee = res.data.groupPolicy.refundFee;
          this.formData.businessSource = res.data.groupPolicy.businessSource;
          this.formData.supplierType = res.data.groupPolicy.supplierType;
          this.formData.supplierId = res.data.groupPolicy.supplierId;
          this.formData.fee = res.data.groupPolicy.fee;
          this.formData.isManyInsures = res.data.groupPolicy.isManyInsures;
          this.formData.beneficiaryType = res.data.groupPolicy.beneficiaryType;
          //
          this.formData.name = res.data.holder.name;
          this.formData.cardNo = res.data.holder.cardNo;
          this.formData.belongIndustry = res.data.holder.belongIndustry;
          this.formData.contactMobile = res.data.holder.contactMobile;
          this.formData.contactMobile1 = res.data.holder.contactMobile1;
          this.formData.contactName = res.data.holder.contactName;
          this.formData.mobile = res.data.holder.mobile;
          this.formData.mobile1 = res.data.holder.mobile1;
          this.formData.contactCardNo = res.data.holder.contactCardNo;
          this.formData.contactCardNo1 = res.data.holder.contactCardNo1;
          this.formData.email = res.data.holder.email;
          this.formData.email1 = res.data.holder.email1;
          this.formData.location = res.data.holder.location;
          this.formData.address = res.data.holder.address;
          this.formData.address1 = res.data.holder.address1;
          this.formData.enterpriseNature = res.data.holder.enterpriseNature;
          this.formData.accountName = res.data.holder.accountName;
          this.formData.accountNumber = res.data.holder.accountNumber;
          this.formData.accountNumber1 = res.data.holder.accountNumber1;
          this.formData.openAccountBank = res.data.holder.openAccountBank;
          //
          this.formData.guarantee = res.data.groupPolicyDetail.guarantee
            ? JSON.parse(res.data.groupPolicyDetail.guarantee)
            : [
                {
                  jobGrade: '', //职业类别
                  planName: '', //计划名称
                  guarantee: '' //保障责任
                }
              ];
          this.formData.projectName = res.data.groupPolicyDetail.projectName;
          this.formData.localtionArea = res.data.groupPolicyDetail.localtionArea;
          this.formData.detailAddress = res.data.groupPolicyDetail.detailAddress;
          this.insuranceContractList = res.data.groupPolicyDetail.contract && JSON.parse(res.data.groupPolicyDetail.contract); //保险合同
          this.insuranceInfoList = res.data.groupPolicyDetail.insureConfirm && JSON.parse(res.data.groupPolicyDetail.insureConfirm); //投保确认书
          this.customerNoticeList = res.data.groupPolicyDetail.insureDeclaration && JSON.parse(res.data.groupPolicyDetail.insureDeclaration); //投保人声明
          this.otherInfoList = res.data.groupPolicyDetail.other && JSON.parse(res.data.groupPolicyDetail.other); //投保人声明
          if (this.editFlag == 'copy' && !reload) {
            this.formData.copyPolicyNo = this.formData.policyNo;
            this.formData.isCopy = 1;
            this.formData.policyNo = '';
          } else {
            this.formData.isCopy = 0;
          }
          this.getProductGrade(this.formData.productCode, true);
          this.selectSupplier(this.formData.supplierType);
          this.$emit('save', res.data);
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    },
    save(isDraft) {
      return new Promise((resolve, reject) => {
        const formData = JSON.parse(JSON.stringify(this.formData));

        if (filter.filterTime(formData.startTime, 'YYYY-MM-DD') > filter.filterTime(formData.endTime, 'YYYY-MM-DD')) {
          this.$notice.error('生效日期不能大于终保日期');
          reject({ showMsg: false });
          return;
        }
        if (filter.filterTime(formData.insureTime, 'YYYY-MM-DD') > filter.filterTime(formData.issueTime, 'YYYY-MM-DD')) {
          this.$notice.error('投保日期不能大于承保日期');
          reject({ showMsg: false });
          return;
        }
        if (filter.filterTime(formData.issueTime, 'YYYY-MM-DD') > filter.filterTime(formData.startTime, 'YYYY-MM-DD')) {
          this.$notice.error('承保日期不能大于生效日期');
          reject({ showMsg: false });
          return;
        }
        const data = {
          isCopy: formData.isCopy, // 是否是复制保单 1是 0否
          copyPolicyNo: formData.copyPolicyNo, // 复制的原保单号
          // 出单信息
          groupPolicy: {
            productCode: formData.productCode,
            productName: formData.productName,
            grade: formData.grade,
            orgId: formData.orgId,
            groupId: formData.groupId,
            salesmanId: formData.salesmanId,
            policyNo: formData.policyNo,
            status: formData.status,
            insureTime: formData.insureTime ? filter.filterTime(formData.insureTime, 'YYYY-MM-DD') : '',
            issueTime: formData.issueTime ? filter.filterTime(formData.issueTime, 'YYYY-MM-DD') : '',
            payTime: formData.payTime ? filter.filterTime(formData.payTime, 'YYYY-MM-DD') : '',
            startTime: formData.startTime ? filter.filterTime(formData.startTime, 'YYYY-MM-DD') : '',
            endTime: formData.endTime ? filter.filterTime(formData.endTime, 'YYYY-MM-DD') : '',
            refundStartTime: formData.refundStartTime ? filter.filterTime(formData.refundStartTime, 'YYYY-MM-DD') : '',
            refundFee: formData.refundFee,
            businessSource: formData.businessSource,
            supplierType: formData.supplierType,
            supplierId: formData.supplierId,
            fee: formData.fee,
            isManyInsures: formData.isManyInsures,
            beneficiaryType: formData.beneficiaryType
          },
          // 投保企业信息  保障责任 标的信息 影响资料
          holder: {
            name: formData.name,
            cardNo: formData.cardNo,
            contactMobile: formData.contactMobile,
            contactName: formData.contactName,
            mobile: formData.mobile,
            contactCardNo: formData.contactCardNo,
            email: formData.email,
            location: formData.location,
            address: formData.address,
            enterpriseNature: formData.enterpriseNature,
            belongIndustry: formData.belongIndustry,
            accountName: formData.accountName,
            accountNumber: formData.accountNumber,
            openAccountBank: formData.openAccountBank
          },
          groupPolicyDetail: {
            guarantee: JSON.stringify(formData.guarantee),
            projectName: formData.projectName,
            localtionArea: formData.localtionArea,
            detailAddress: formData.detailAddress,
            contract: JSON.stringify(this.insuranceContractList), //保险合同
            insureConfirm: JSON.stringify(this.insuranceInfoList), //投保确认书
            insureDeclaration: JSON.stringify(this.customerNoticeList), //投保人声明
            other: JSON.stringify(this.otherInfoList) //其他
          }
        };
        // 编辑
        if (this.editFlag == 'edit') {
          data.groupPolicy.orderNo = this.detailData.groupPolicy.orderNo;
          data.groupPolicy.id = this.detailData.groupPolicy.id;
          data.groupPolicyDetail.id = this.detailData.groupPolicyDetail.id;
          data.holder.id = this.detailData.holder.id;
        }

        // 草稿
        if (isDraft) {
          this.$http({
            type: 'POST',
            url: this.draftId ? '' : '/buz/groupPolicyDraft/save',
            data
          }).then(res => {
            this.$notice.success('保存成功');
            this.back('/orderManage/group/draftList');
          });
        } else {
          // 新增
          this.$refs.formInline.validate().then(isok => {
            if (!isok) {
              reject({ page: 'policyInfo', showMsg: true });
              return;
            }

            this.$http({
              type: 'POST',
              url: this.editFlag == 'edit' ? '/buz/grouppolicy/enter/update' : '/buz/grouppolicy/enter/add',
              data
            })
              .then(res => {
                resolve();
                this.$notice.success('保存成功');
                if (this.editFlag == 'add' || this.editFlag == 'copy') {
                  this.back({
                    url: '/orderManage/group/editGroupPolicy',
                    query: {
                      policyNo: formData.policyNo,
                      editFlag: 'edit'
                    }
                  });
                }
              })
              .catch(e => {
                reject({ page: 'policyInfo' });
              });
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.tips {
  display: flex;
}
.body {
  padding-bottom: 50px;

  .bottom-25-border {
    border-bottom: 1px dotted #e9e9e9;
    margin-bottom: 25px;
  }

  .xzbtn,
  .scbtn {
    width: calc(50% - 5px);
  }

  .scbtn {
    margin-left: 10px;
  }

  .additionBtn,
  .benefitBtn {
    text-align: center;
    margin-bottom: 25px;

    .xzbtn,
    .scbtn {
      width: 120px;
    }

    .scbtn {
      margin-left: 10px;
    }
  }
  .title {
    font-weight: bold;
    font-size: 16px;
    color: #3c464f;
    margin-bottom: 20px;
    .title-desc {
      border-bottom: 3px solid #236dff;
      display: inline-block;
    }
    Button {
      margin-left: 20px;
      cursor: pointer;
    }
  }

  .policy-holder-form {
    @media screen and (max-width: 1400px) {
      .certy-vali {
        width: 33.3%;
        display: flex;
        margin: 0;
      }
      .address {
        padding-right: 30px;
      }
    }

    @media screen and (min-width: 1401px) {
      .certy-vali {
        width: 33%;
        display: flex;
        margin: 0;
      }

      .address {
        padding-right: 0;
      }
    }

    .certy-vali1 {
      width: 35%;
    }
  }

  .nav-second-tab {
    margin-top: 10px;
    border-bottom: 1px solid #ececec;

    .tab-body {
      width: 40%;
      text-align: center;
      display: flex;

      span {
        flex: 1;
        font-size: 16px;
        font-family: PingFangSC-Regular;
        color: #666666;
        line-height: 40px;
        display: inline-block;
        cursor: pointer;
      }

      .active {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 600;
        border-bottom: 3px solid #236dff;
        color: #236dff;
      }
    }
  }
}
</style>
